import {
	defaultTqcTestDtlDto,
	TqcTestDtlDto,
	defaultTqcTestHdrDto,
	TqcTestHdrDto,
} from "src/dtos/tqctest/tqcTestDto";

export interface TQC2060_R01HeaderDto extends TqcTestHdrDto {
}

export interface TQC2060_R01DetailDto extends TqcTestDtlDto {
}

export interface TQC2060_R01Dto {
	tqcTestHeaderDto: TQC2060_R01HeaderDto;
	tqcTestDetailDtoList: TQC2060_R01DetailDto[];
}

export const defaultTQC2060_R01HdrDto: TQC2060_R01HeaderDto = {
	...defaultTqcTestHdrDto,
};

export const defaultTQC2060_R01DtlDto: TQC2060_R01DetailDto = {
	...defaultTqcTestDtlDto,
};

export const defaultTQC2060_R01Dto: TQC2060_R01Dto = {
	tqcTestHeaderDto: defaultTQC2060_R01HdrDto,
	tqcTestDetailDtoList: [],
};
